import React from 'react';

import {
  Dialog,
  IconButton,
  Icon,
  DialogContentProps,
  createStyles,
  Theme,
  withStyles,
  WithStyles,
  useTheme,
  useMediaQuery,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
} from '@material-ui/core';

// styles
import { useStyles } from './styles';

export interface CustomModalProps extends DialogContentProps {
  contentTitle?: JSX.Element;
  openValue: boolean;
  width?: number;
  height?: number;
  customStyles?: React.CSSProperties;
  customContentStyles?: React.CSSProperties;
  contentActions?: JSX.Element | null | undefined;
  fnClose: (event: React.ChangeEvent<any>) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: (event: React.ChangeEvent<any>) => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Icon>close</Icon>
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const CustomModal: React.FC<CustomModalProps> = props => {
  const {
    openValue,
    children,
    contentTitle,
    contentActions,
    customContentStyles,
    customStyles,
    dividers,
    fnClose,
  } = props;

  const classes = useStyles(props);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        className={classes.dialogContainer}
        onClose={fnClose}
        aria-labelledby="customized-dialog-title"
        open={openValue}
        style={{ ...customStyles }}
      >
        <DialogTitle id="customized-dialog-title" onClose={fnClose}>
          {contentTitle}
        </DialogTitle>
        <DialogContent
          style={{ padding: 24, ...customContentStyles }}
          dividers={dividers}
        >
          {children}
        </DialogContent>
        {contentActions && <DialogActions>{contentActions}</DialogActions>}
      </Dialog>
    </>
  );
};
